import React, { useState, useEffect, useRef } from "react";
import Footer from "../../components/HeaderFooter/Footer";
import ContentLayout from "../../components/projectComponents/ProjectListingLayout";
import Steps from "../../components/Steps";
import ProjectDescription from "../../components/projectComponents/ProjectDescription";
import TaskAndTeam from "../../components/projectComponents/TaskAndTeam";
import ProjectDates from "../../components/projectComponents/ProjectDates";
import AdditionalDetails from "../../components/projectComponents/AdditionalDetails";
import Summary from "../../components/projectComponents/Summary";
import Confirmation from "../../components/projectComponents/Confirmation";
import { createNewProjects, updateProjectById } from "../../services/API";
import "../../styles/projectStyles/NewProject.css";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";

const NewProject = () => {
  const projectDescriptionRef = useRef(null);
  const navigate = useNavigate();
  const [currentStepIndex, setCurrentStepIndex] = useState(0);
  const [isConfirmationPage, setIsConfirmationPage] = useState(false);
  const [projectData, setProjectData] = useState({});
  const [files, setFiles] = useState([]);

  const steps = [
    "Project Description",
    "Tasks and Team",
    "Project Dates",
    "Additional Details",
    "Summary",
  ];

  const handleNext = () => {
    if (currentStepIndex < steps.length - 1) {
      if (currentStepIndex === 0) {
        console.log("is valid", projectDescriptionRef.current);

        if (projectDescriptionRef.current) {
          const isValid = projectDescriptionRef.current.validateForm();
          console.log("is valid", isValid);
          if (!isValid) {
            return;
          }
          setCurrentStepIndex((prevIndex) => prevIndex + 1);
        }
      }
      if (currentStepIndex == 1) {
        const taskAndTeamErrors = JSON.parse(
          localStorage.getItem("taskAndTeamErrors")
        );
        console.log(taskAndTeamErrors.isValid);
        if (taskAndTeamErrors.isValid) {
          setCurrentStepIndex(currentStepIndex + 1);
          console.log("TASK ", taskAndTeamErrors.isValid);
        } else {
          alert("Please enter valid inputs");
        }
      }

      if (currentStepIndex == 2) {
        const projectDatesErrors = JSON.parse(
          localStorage.getItem("projectDatesErrors")
        );
        console.log(projectDatesErrors.isValid);
        if (projectDatesErrors.isValid) {
          setCurrentStepIndex(currentStepIndex + 1);
          console.log("TASK ", projectDatesErrors.isValid);
        }
      }
      if (currentStepIndex == 3) {
        setCurrentStepIndex(currentStepIndex + 1);
      }
    } else {
      const isUpdate = Boolean(localStorage.getItem("projectId"));
      if (!isUpdate) {
        handleNewSubmitProject();
      } else {
        handleSubmitProject();
      }
    }
  };

  const handleFileUpload = (uploadedFiles) => {
    setFiles((prevFiles) => [...prevFiles, ...uploadedFiles]);
  };
  const combineDateAndTime = (date, time) => {
    // Ensure `date` is in valid dayjs format
    const formattedDate = dayjs(date).format("YYYY-MM-DD");

    // Combine the date and time strings and parse into a dayjs object
    const combinedDateTime = dayjs(
      `${formattedDate} ${time}`,
      "YYYY-MM-DD h:mm A"
    );

    // Return in the desired format
    return combinedDateTime.isValid()
      ? combinedDateTime.format("YYYY-MM-DD HH:mm:ss")
      : "Invalid Date";
  };

  const handleNewSubmitProject = async () => {
    const projectData = JSON.parse(localStorage.getItem("projectDescription"));
    const dateRanges = JSON.parse(localStorage.getItem("dateRanges")) || {};
    const selectedTasks =
      JSON.parse(localStorage.getItem("selectedTasks")) || [];

    const formattedTasklist = selectedTasks.map((task) => ({
      Task_ID: task.taskid,
      Subtasklist: task.subtasklist?.map((subtask) => ({
        Subtask_ID: subtask.value || "",
      })),
      Employees: task.employeelist?.flatMap((employee, teamIndex) => {
        const taskId = task.taskid;
        const employeeDateRanges = dateRanges[taskId]?.[teamIndex] || [];

        return employeeDateRanges.map((range) => {
          const combinedStartTime = combineDateAndTime(
            range.startDate
              ? dayjs(range.startDate).format("YYYY-MM-DD")
              : "2024-01-01",
            range.startTime || "09:00 AM"
          );

          const combinedEndTime = combineDateAndTime(
            range.endDate
              ? dayjs(range.endDate).format("YYYY-MM-DD")
              : "2024-01-01",
            "12:00 AM"
          );

          return {
            Employee_ID: employee.value,
            Time_Start: combinedStartTime,
            Time_Finish: combinedEndTime,
          };
        });
      }),
    }));

    const formattedProjectData = {
      projectId: projectData.projectID || null,
      Project_Description: projectData.overview || "",
      Address: projectData.address || "",
      Post_Code: projectData.housecode || "",
      Contact_Phone: projectData.phoneNumber || "",
      Contact_Email: projectData.email || "",
      Created_By: projectData.Created_By || 1,
      Status: projectData.Status || "Not Started",
      Tasklist: formattedTasklist,
    };
    // console.log("Formatted Project Data:", formattedProjectData);

    // Prepare FormData for submission
    const formData = new FormData();
    formData.append("projectData", JSON.stringify(formattedProjectData));

    const uploadedFiles =
      JSON.parse(localStorage.getItem("uploadedFiles")) || [];
    setFiles(uploadedFiles);

    if (Array.isArray(files)) {
      files.forEach((file) => {
        formData.append("projectAttachments", file);
      });
    } else {
      console.error("Files are not in the expected array format.");
    }

    try {
      console.log("Submitting FormData...");
      const response = await createNewProjects(formData);

      if (response.status === 201) {
        console.log("Project created successfully:");
        setIsConfirmationPage(true);
      } else {
        console.error("Error from server:", response.data);
        alert(`Error: ${response.data.message}`);
      }
    } catch (error) {
      console.error("Error submitting project:", error);
    }
  };

  const handleSubmitProject = async () => {
    const localProjectData = JSON.parse(
      localStorage.getItem("projectDescription")
    );
    const isUpdate = Boolean(localStorage.getItem("projectId"));
    const dateRanges = JSON.parse(localStorage.getItem("dateRanges")) || {};
    const selectedTasks =
      JSON.parse(localStorage.getItem("selectedTasks")) || [];

    const formattedTasklist = selectedTasks.map((task) => ({
      Task_ID: task.taskid,
      Subtasklist: task.subtasklist?.map((subtask) => ({
        Subtask_ID: subtask.value || "",
      })),
      Employees: task.employeelist?.flatMap((employee, teamIndex) => {
        const taskId = task.taskid;
        const employeeDateRanges = dateRanges[taskId]?.[teamIndex] || [];

        return employeeDateRanges.map((range) => ({
          Employee_ID: employee.value,
          Time_Start: combineDateAndTime(
            range.startDate || "2024-01-01",
            range.startTime || "09:00 AM"
          ),
          Time_Finish: combineDateAndTime(
            range.endDate || "2024-01-01",
            "12:00 AM"
          ),
        }));
      }),
    }));

    let formattedProjectData = {};

    if (isUpdate) {
      formattedProjectData = {
        projectData: {
          Project_Description: localProjectData.overview || "",
          Address: localProjectData.address || "",
          Post_Code: localProjectData.housecode || "",
          Contact_Phone: localProjectData.phoneNumber || "",
          Contact_Email: localProjectData.email || "",
          Created_By: localProjectData.Created_By || "1",
          Status: localProjectData.Status || "Not Started",
          Tasklist: formattedTasklist,
        },
      };
    } else {
      formattedProjectData = {
        projectData: {
          Project_Description: localProjectData.overview || "",
          Address: localProjectData.address || "",
          Post_Code: localProjectData.housecode || "",
          Contact_Phone: localProjectData.phoneNumber || "",
          Contact_Email: localProjectData.email || "",
          Created_By: localProjectData.Created_By || "1",
          Status: localProjectData.Status || "Not Started",
          Tasklist: formattedTasklist,
        },
      };
    }

    console.log("Formatted Project Data: new funtion", formattedProjectData);

    const formData = new FormData();
    formData["projectData"] = JSON.stringify(formattedProjectData);

    try {
      const response = isUpdate
        ? await updateProjectById(
            localStorage.getItem("projectId"),
            JSON.stringify(formattedProjectData)
          )
        : await createNewProjects(formData);

      if (response.status === 200 || response.status === 201) {
        console.log(
          isUpdate
            ? "Project updated successfully!"
            : "Project created successfully!"
        );
        setIsConfirmationPage(true);
      } else {
        console.error("Error from server:", response.data);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handlePrevious = () => {
    if (currentStepIndex > 0) {
      setCurrentStepIndex(currentStepIndex - 1);
    } else {
      const pd = JSON.parse(localStorage.getItem("projectId")) || "";
      if (pd) {
        navigate(`/projectDetails/${pd}`);
      }
    }
  };

  const handleCancel = () => {
    const userConfirmed = window.confirm(
      "Are you sure you want to cancel? This action will clear all your unsaved data."
    );

    if (userConfirmed) {
      // Clear project-related data from localStorage
      localStorage.removeItem("projectDescription");
      localStorage.removeItem("projectDescriptionErrors");
      localStorage.removeItem("taskAndTeamErrors");
      localStorage.removeItem("projectDatesErrors");
      localStorage.removeItem("selectedTasks");
      localStorage.removeItem("dateRanges");
      localStorage.removeItem("uploadedFiles");
      localStorage.removeItem("projectId");

      // Navigate back to the Projects page
      navigate("/projects");
    }
  };
  // const handleCancel = () => {
  //   // Clear project-related data from localStorage
  //   localStorage.removeItem("projectDescription");
  //   localStorage.removeItem("projectDescriptionErrors");
  //   localStorage.removeItem("taskAndTeamErrors");
  //   localStorage.removeItem("projectDatesErrors");
  //   localStorage.removeItem("selectedTasks");
  //   localStorage.removeItem("dateRanges");
  //   localStorage.removeItem("uploadedFiles");
  //   localStorage.removeItem("projectId");

  //   // Navigate back to the Projects page
  //   navigate("/projects");
  // };

  const renderStepContent = () => {
    switch (currentStepIndex) {
      case 0:
        return (
          <ProjectDescription
            ref={projectDescriptionRef}
            data={projectData}
            setData={setProjectData}
          />
        );
      case 1:
        return <TaskAndTeam data={projectData} setData={setProjectData} />;
      case 2:
        return <ProjectDates data={projectData} setData={setProjectData} />;
      case 3:
        return (
          <AdditionalDetails
            data={projectData}
            setData={setProjectData}
            files={files}
            setFiles={setFiles}
            handleFileUpload={handleFileUpload}
          />
        );
      case 4:
        return <Summary data={projectData} />;
      default:
        return (
          <ProjectDescription
            ref={projectDescriptionRef}
            data={projectData}
            setData={setProjectData}
          />
        );
    }
  };

  return (
    <div className="new-projects-container">
      <ContentLayout activeTab="Projects" />
      <div className="newprojectScreen">
        {isConfirmationPage ? (
          <Confirmation />
        ) : (
          <>
            <Steps
              currentStep={steps[currentStepIndex]}
              setCurrentStep={(step) =>
                setCurrentStepIndex(steps.indexOf(step))
              }
              steps={steps}
            />
            {renderStepContent()}
          </>
        )}
      </div>

      <div className="p-navigation-buttons">
        {!isConfirmationPage && (
          <>
            <button onClick={handleCancel} className="p-cancel">
              {" "}
              Cancel{" "}
            </button>
            <div>
              <button onClick={handlePrevious} className="p-previous">
                {" "}
                Previous{" "}
              </button>
              <button onClick={handleNext} className="p-next">
                {" "}
                {currentStepIndex === steps.length - 1 ? "Submit" : "Next"}{" "}
              </button>
            </div>
          </>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default NewProject;
